import {
	closestRequired,
	qsaRequired,
	qsRequired,
	targetRequired,
} from '@/scripts/core/global'
import {
	addGwpVariant,
	cartSectionsAsString,
	getGwpVariantToAdd,
	getPayloadForLineAdd,
} from '@/scripts/core/features'
import { CartDrawer } from '@/scripts/cart/CartDrawer'
import { ProductFormGeneric } from '@/scripts/product-form-context/ProductFormGeneric'

export class ProductQuiz extends ProductFormGeneric {
	static htmlSelector = 'product-quiz'
	result: number
	quizAnswerButtons: NodeListOf<HTMLButtonElement>
	quizVariantIDInput: HTMLInputElement
	quizResultContainer: HTMLElement
	quizQuestionsContainer: HTMLElement
	form: HTMLFormElement
	constructor() {
		super()

		this.result = 0 // 2 or more == big head

		this.quizAnswerButtons = qsaRequired('[quiz-btn]', this)
		this.quizVariantIDInput = qsRequired('[data-quiz-variant-id]', this)
		this.quizResultContainer = qsRequired('[quiz-result-container]', this)
		this.quizQuestionsContainer = qsRequired('[quiz-questions]', this)

		if (this.quizAnswerButtons.length > 0) {
			this.quizAnswerButtons.forEach((answerButton) => {
				answerButton.addEventListener(
					'click',
					this.onQuizAnswer.bind(this)
				)
			})
		}
		this.setMinHeight()

		const resizeObserver = new ResizeObserver((_: ResizeObserverEntry[]) =>
			this.setMinHeight()
		)
		resizeObserver.observe(this.quizResultContainer)

		this.form = qsRequired('form', this)
		this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
	}

	setMinHeight() {
		this.quizQuestionsContainer.style.minHeight = `${this.quizResultContainer.offsetHeight}px`
	}

	onQuizAnswer(event: Event) {
		const target = targetRequired(event)
		if (target.getAttribute('quiz-btn') === 'yes') {
			this.result += 1
		}
		target.classList.add('selected')
		const currentQuizItem = closestRequired(target, '[quiz-item]')
		currentQuizItem.classList.remove('active')
		const nextSibling = currentQuizItem.nextSibling
		if (!(nextSibling instanceof HTMLElement)) {
			const siblingAfterNextSibling =
				nextSibling?.nextSibling as HTMLElement
			if (!(siblingAfterNextSibling instanceof HTMLElement))
				throw new Error('siblingAfterNextSibling is not HTMLElement')
			siblingAfterNextSibling.classList.add('active')
		} else {
			nextSibling.classList.add('active')
		}

		if (currentQuizItem.classList.contains('final')) {
			const hideResult =
				this.result < 2
					? qsRequired('[result-big-head]')
					: qsRequired('[result-small-head]')
			const variantId =
				this.result < 2
					? this.quizVariantIDInput.dataset.smallVariantId
					: this.quizVariantIDInput.dataset.bigVariantId

			hideResult.style.display = 'none'
			if (!variantId) throw new Error('variantId is not defined')
			this.quizVariantIDInput.value = variantId
		}
	}

	async onSubmitHandler(evt: Event) {
		evt.preventDefault()

		const cartDrawer = qsRequired<CartDrawer>('cart-drawer')

		const variantId = parseInt(this.quizVariantIDInput.value)
		const { productVariants } = this.getContext()
		const currentVariant = productVariants.find(
			(variant) => variant.id === variantId
		)
		if (!currentVariant) throw new Error('currentVariant is not defined')
		const item = {
			quantity: 1,
			id: variantId,
			price: currentVariant.price
		}

		// TODO get price in form

		const items = getPayloadForLineAdd(item)
		// resolved before the request below, while the cart still holds the
		// pre-add state this decision is based on
		const gwpVariantId = getGwpVariantToAdd({
			type: 'line_add',
			lineItem: item,
		})

		const formData = {
			items,
			sections: cartSectionsAsString(),
			sections_url: window.location.pathname,
		}

		cartDrawer.setActiveElement(document.activeElement)
		const config = {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Accept: `application/javascript`,
				'X-Requested-With': 'XMLHttpRequest',
			},
			body: JSON.stringify(formData),
		}

		void (await fetch(window.routes.cart_add_url, config)
			.then((response) => response.json())
			.then(async (response) => {
				if (response.status) {
					return
				}

				let sections = response.sections
				if (gwpVariantId) {
					const gwpSections = await addGwpVariant(gwpVariantId)
					if (gwpSections) {
						sections = gwpSections
					}
				}

				cartDrawer.renderContents({ ...response, sections })
			})
			.catch((e) => {
				console.error(e)
			})
			.finally(() => {
				cartDrawer.classList.remove('is-empty')
			}))
	}
}
